module.exports = __webpack_public_path__ + "fonts/76436ebe85a44818e4efe81f1d807eb2.txt";